<template>
	<div>
		<van-popup v-model="district_show" position="bottom" closeable
			style="border-radius: 8px 8px 0 0;background-color: #F6F7F9;">
			<div class="cmbc_pop width_100">
				<div class="cmbc_pop_title width_100 text_align_center font_size_34 color_333333 font_weight_600">请选择
				</div>


				<div class="spl_distinct">
					<div class="spl_distinct_title">城市</div>
					<div class="spl_distinct_list_block spl_distinct_list_block2">
						<div class="spl_distinct_item">
							<img src="../resource/address.png" alt="" />
							{{search_params && search_params.city_name ? search_params.city_name : '--'}}
						</div>
					</div>
					<div class="spl_distinct_stitle">区域</div>
					<div class="spl_distinct_list_block spl_distinct_list_block2">
						<div @click="selectDistrict({districtId:'',name:'全部'})" 
						:class="[{'spl_distinct_itemS':search_params && search_params.district_id==''},'spl_distinct_item']">全部</div>
					</div>
					<div class="spl_distinct_list">
						<div v-for="(item,index) in distinct_list" :key="'distinct'+index" class="spl_distinct_list_block display_center_start">
							<div @click="selectDistrict(item)" 
							:class="[{'spl_distinct_itemS':search_params && search_params.district_id==item.districtId},'spl_distinct_item spl_distinct_item_bot']">{{item.name}}</div>
						</div>
					</div>
				</div>

			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		getDistricts
	} from '../../src/api/api.js'
	export default {
		props: {
			search_params:{
				type: Object,
			}
		},
		data() {
			return {
				district_show: false,
				distinct_list:[],
				// remainder:0
				// distinct_list_fixed:[]
			}
		},
		mounted() {},
		methods: {
			// 获取区域列表
			async getDistrictList(){
				this.$RCLoading.show();
				var $this=this
				var params={
					cityId:this.search_params.city_id
				}
				try {
					var res=await getDistricts(params)
					// console.log(res);
					$this.distinct_list=res.data
					$this.openDistrictPop()
					// $this.fixedRowEmpty()
					$this.$RCLoading.hide();
				} catch (error) {
					//TODO handle the exception
				}
			},
			openDistrictPop(){
				this.district_show=true
			},
			closeDistrictPop(){
				this.district_show=false
			},
			selectDistrict(e){
				// console.log('search_params',this.search_params);
				// console.log('selectDistrict',e);
				
				var params={
					city_id:this.search_params.city_id,
					city_name:this.search_params.city_name,
					district_id:e.districtId,
					district_name:e.name,
				}
				this.$emit('selectDistrict',params)
				this.closeDistrictPop()
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;

	.cmbc_pop {
		padding: 0 20*@vm_base 40*@vm_base 20*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 40*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 40*@vm_base);

		.cmbc_pop_title {
			padding: 40*@vm_base;
		}

	}

	.spl_distinct {
		width: 100%;
		background-color: #FFFFFF;
		padding: 30*@vm_base 20*@vm_base 20*@vm_base 20*@vm_base;

		.spl_distinct_title {
			font-size: 26*@vm_base;
			color: #666666;
			padding-bottom: 30*@vm_base;
			padding-left: 10*@vm_base;
		}
		.spl_distinct_list_block{
			width: calc(100% / 3);
		}
		.spl_distinct_list_block2{
			margin-left: 10*@vm_base;
		}
		.spl_distinct_item {
			width: calc(100% - 20*@vm_base);
			height: 60*@vm_base;
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			font-size: 28*@vm_base;
			color: #333333;
			border: 1*@vm_base solid #D9D9D9;
			border-radius: 4*@vm_base;
			
		}

		.spl_distinct_itemS {
			background-color: #F77F28;
			border: 1*@vm_base solid #F77F28;
			color: #FFFFFF;
		}

		.spl_distinct_item_bot {
			margin-bottom: 20*@vm_base;
		}

		.spl_distinct_item img {
			width: 30*@vm_base;
			height: 30*@vm_base;
			margin-right: 10*@vm_base;
		}

		.spl_distinct_stitle {
			font-size: 26*@vm_base;
			color: #666666;
			padding: 40*@vm_base 0 30*@vm_base 10*@vm_base;
		}

		.spl_distinct_list {
			width: 100%;
			padding-top: 30*@vm_base;
			display: flex;
			justify-content: flex-start;
			align-items: flex-start;
			flex-wrap: wrap;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/pop_district.vue